<template>
	<span
		title="Click to copy to clipboard"
		:class="['clipboard-copy', classes, { 'copied-show': copiedShow }]"
		@click="copyToClipboard"
		role="button"
	>
		<span class="slot">
			<slot></slot>
		</span>
		<span class="copied">
			{{ copyError ? 'Error copying' : 'Copied!' }}
		</span>
	</span>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
	props: {
		textOverride: {
			type: String,
			default: '',
		},
		classes: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			copiedShow: false,
			copyError: false,
		};
	},
	methods: {
		copyToClipboard() {
			// Happens on insecure contexts (HTTP)
			if (!navigator.clipboard) {
				return;
			}

			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			let text = (this.$slots as any).default()[0].children;
			if (this.textOverride) {
				text = this.textOverride;
			}

			// Sometimes writeText fails due to bowswer security settings
			// even if the clipboard API is available. We've seen this happen
			// when the app is inside an iframe.
			try {
				navigator.clipboard
					.writeText(text)
					.then(
						() => {
							this.copyError = false;
						},
						() => {
							this.copyError = true;
						}
					)
					.finally(() => {
						this.copiedShow = true;
						setTimeout(() => {
							this.copiedShow = false;
						}, 1500);
					});
			} catch (error) {
				console.log(error);
				this.copyError = true;
			}
		},
	},
});
</script>

<style scoped lang="scss">
.clipboard-copy {
	display: inline-grid;
	text-align: center;

	.slot {
		grid-area: 1/1;
		transition: opacity 0.3s;
	}

	.copied {
		grid-area: 1/1;
		opacity: 0;
		transition: opacity 0.3s;
		user-select: none;
	}

	&.copied-show {
		.slot {
			opacity: 0;
		}

		.copied {
			opacity: 1;
		}
	}
}
</style>
